import styled from "styled-components";

export const Wrapper = styled.section`
  margin-top: 48px;
  padding: 28px 16px 16px;
  border-radius: 20px;
  background: ${({ theme }) => theme.palette.primary.blue50};

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 64px;
    padding: 40px 40px 24px;
  }
`;

export const SectionTitle = styled.h2`
  margin: 0 0 20px;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.palette.black.default};

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-bottom: 24px;
    font-size: 2rem;
  }
`;

export const Question = styled.details`
  background: #fff;
  border-radius: 14px;
  margin-bottom: 8px;
  box-shadow: 0 1px 2px hsl(216 40% 30% / 0.06);

  &[open] {
    box-shadow: 0 10px 28px hsl(216 40% 30% / 0.08);
  }

  &[open] svg {
    transform: rotate(180deg);
  }
`;

export const Summary = styled.summary`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px 16px;
  cursor: pointer;
  list-style: none;
  border-radius: 14px;

  &::-webkit-details-marker {
    display: none;
  }

  &:hover span {
    background: ${({ theme }) => theme.palette.primary.blue100};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primary.blue500};
    outline-offset: 2px;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 18px 20px;
  }
`;

export const QuestionTitle = styled.h3`
  margin: 0;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 1rem;
  font-weight: 650;
  letter-spacing: -0.01em;
  line-height: 1.35;
  color: ${({ theme }) => theme.palette.primary.blue900};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: 1.0625rem;
  }
`;

export const Chevron = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  border-radius: 999px;
  background: ${({ theme }) => theme.palette.primary.blue50};
  color: ${({ theme }) => theme.palette.primary.blue700};
  transition: background 0.2s ease;

  svg {
    width: 18px;
    height: 18px;
    transition: transform 0.28s cubic-bezier(0.16, 1, 0.3, 1);
  }
`;

export const Answer = styled.p`
  margin: 0;
  padding: 0 16px 18px;
  max-width: 68ch;
  font-size: 0.975rem;
  line-height: 1.65;
  color: ${({ theme }) => theme.palette.primary.blue800};
  animation: faqAnswerIn 0.28s cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes faqAnswerIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 0 20px 20px 20px;
    font-size: 1rem;
  }
`;

export const AnswerLink = styled.a`
  color: ${({ theme }) => theme.palette.primary.blue700};
  font-weight: 650;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 1px;

  &:hover {
    color: ${({ theme }) => theme.palette.secondary.orange600};
  }
`;
